import React from "react";
import Page1 from "./Container/components/Pages/Page1/Page1";

const App = () => {
  return (
    <div>
      <Page1 />
    </div>
  );
};

export default App;
